var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRegionTicketIc(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.7 17.4004C6.05396 17.7709 5 18.3403 5 18.9787C5 20.0953 8.22355 21.0004 12.2 21.0004C16.1765 21.0004 19.4 20.0953 19.4 18.9787C19.4 18.3403 18.346 17.7709 16.7 17.4004",
    stroke: "#172B4D",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.45 9.30078C14.45 10.5434 13.4426 11.5508 12.2 11.5508C10.9573 11.5508 9.94995 10.5434 9.94995 9.30078C9.94995 8.05814 10.9573 7.05078 12.2 7.05078C13.4426 7.05078 14.45 8.05814 14.45 9.30078Z",
    stroke: "#172B4D",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13.3316 16.9442C13.028 17.2366 12.6223 17.4 12.2001 17.4C11.7778 17.4 11.3721 17.2366 11.0685 16.9442C8.28877 14.2507 4.56357 11.2417 6.38024 6.87336C7.36249 4.51139 9.72035 3 12.2001 3C14.6798 3 17.0376 4.5114 18.0198 6.87336C19.8342 11.2363 16.1181 14.26 13.3316 16.9442Z",
    stroke: "#6929E2",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRegionTicketIc);
export default __webpack_public_path__ + "static/media/region_ticket_ic.7df17fc23d5f673fc793dc8a8dd7d1d4.svg";
export { ForwardRef as ReactComponent };